import { render, staticRenderFns } from "./CertificationModal.vue?vue&type=template&id=3ecb5542&"
import script from "./CertificationModal.vue?vue&type=script&lang=js&"
export * from "./CertificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports